import { render } from "./ProfileEditFormPanelNewTheme.vue?vue&type=template&id=ef0f7f48&scoped=true"
import script from "./ProfileEditFormPanelNewTheme.vue?vue&type=script&lang=js"
export * from "./ProfileEditFormPanelNewTheme.vue?vue&type=script&lang=js"

import "./ProfileEditFormPanelNewTheme.vue?vue&type=style&index=0&id=ef0f7f48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef0f7f48"]])

export default __exports__